import store from '../../store';
import {
  URL_FB_GET_MEDIAS,
  URL_FB_GET_STORIES,
  URL_FB_GET_COMMENTS,
  URL_FB_GET_USER,
  URL_TEMPLATE_GET_MEDIAS,
  URL_TEMPLATE_GET_USER,
  URL_INSTAGRAM_GET_USER,
  URL_INSTAGRAM_GET_MEDIAS,
  MEDIAS_DATA_ERROR,
} from '../../constants';
import { creategetRequest } from './request';
import {
  convertDataToProGalleryItems,
  getCountImageNeedToDisplay,
  createHeaders,
  buildError,
} from '../more/utils';
import sendBIMediaErrors from '../more/sendBIMediaErrors';
import { setCachedData, setMediasError } from '../appActions';

import { GALLERY_TYPES } from '../../constants/proGalleryConstants';
import WixService from '../services/WixService';

const { dispatch } = store;
const url = 'api/';

export const getTemplateUser = (demoAccountId) => {
  return creategetRequest(url + URL_TEMPLATE_GET_USER, {
    demoAccountId: demoAccountId || '39731480281',
  })
    .then((res) => res.data.data)
    .catch((err) => err);
};

export const getTemplateMedias = (demoAccountId) => {
  return creategetRequest(url + URL_TEMPLATE_GET_MEDIAS, {
    demoAccountId: demoAccountId || '39731480281',
  })
    .then((res) => {
      const mediasData = res.data;
      mediasData.data = mediasData.data.map((media, index) => {
        return {
          ...media,
          timestamp: new Date().setDate(new Date().getDate() - (index + 1) * 3),
        };
      });
      const pagination = mediasData.pagination;
      const medias =
        mediasData && mediasData.data
          ? convertDataToProGalleryItems(mediasData.data)
          : [];
      return { medias, pagination };
    })
    .catch((err) => err);
};

export const getInstagramUser = () => {
  const { isBusinessApp } = store.getState().appReducer;

  return creategetRequest(
    url + (isBusinessApp ? URL_FB_GET_USER : URL_INSTAGRAM_GET_USER),
  )
    .then((res) => {
      if (res.data.code === 403) throw new Error('Error code 403');
      if (res.data.code === 444) throw new Error('Old Api Error code 444');
      const userData = isBusinessApp
        ? res.data?.payload
        : res.data?.payload?.data;
      if (!userData) throw new Error('Empty User Response');
      if (res.data.fromCache) userData.isCache = true;
      return userData;
    })
    .catch((err) =>
      console.error(
        'Error in instagramApi.js, getInstagramUser',
        err,
        'isBusinessApp:',
        isBusinessApp,
      ),
    );
};

export const getInstagramMedias = (from, count) => {
  const { isBusinessApp } = store.getState().appReducer;

  if (!count) {
    count = getCountImageNeedToDisplay(GALLERY_TYPES.FEED) + 1;
  }

  return creategetRequest(
    url + (isBusinessApp ? URL_FB_GET_MEDIAS : URL_INSTAGRAM_GET_MEDIAS),
    {
      from,
      count,
    },
  )
    .then((res) => {
      if (res.data.code === 403)
        throw buildError(res.data.code, res.data.message);
      if (res.data.code === 444) throw res.data;

      if (res.data.fromCache) {
        if (WixService.getViewMode() === 'editor') {
          sendBIMediaErrors(res.data);
          setMediasError(res.data)(dispatch);
        } else {
          setCachedData(res.data)(dispatch);
        }
      }

      // In case of old user
      if (res.data.message === 'Old user token') {
        throw res.data;
      }

      const mediasData = res.data.payload;
      const pagination = mediasData.pagination;
      const medias =
        mediasData && mediasData.data
          ? convertDataToProGalleryItems(mediasData.data)
          : [];

      return { medias, pagination };
    })
    .catch(async (err) => {
      if (err.code && err.message) {
        throw err;
      }
      let mediasErr = null;
      mediasErr = (err.response.data && err.response.data.message) || {
        code: 400,
        message: 'General Error',
      };
      if (typeof mediasErr === 'string') {
        mediasErr = err.response.data;
      }
      throw mediasErr;
    });
};

export const getStories = (isTemplate) => {
  const isEditorX = WixService.isEditorX();

  return creategetRequest(url + URL_FB_GET_STORIES, { isTemplate, isEditorX })
    .then((res) => {
      return res.data.payload;
    })
    .catch();
};

export const getComments = (
  mediaId,
  after,
  accessToken,
  userId,
  isTemplate,
  demoAccountId,
) => {
  return creategetRequest(
    url + URL_FB_GET_COMMENTS,
    { mediaId, after, isTemplate, demoAccountId },
    createHeaders(accessToken, userId, true),
  )
    .then((res) => {
      return res.data.payload;
    })
    .catch((err) => err);
};
